import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.settings');
import { AfterViewInit, OnInit, Input, NgZone } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-settings',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.settings/view.scss */
@charset "UTF-8";
.glass-card {
  background-color: rgba(255, 255, 255, 0.6);
  /* bg-white/60 */
  backdrop-filter: blur(16px);
  /* backdrop-blur-lg */
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);
  /* shadow-lg */
  border-radius: 1rem;
  /* rounded-2xl */
  padding: 1.5rem;
  /* p-6 */
  transition: all 0.2s;
  border: 1px solid rgba(255, 255, 255, 0.2);
  /* border-white/20 */
}

.glass-card:hover {
  box-shadow: 0 30px 60px -12px rgba(0, 0, 0, 0.35), 0 10px 20px -5px rgba(0, 0, 0, 0.1);
  /* 더 강한 shadow */
  transform: scale(1.02);
}

.animate-gradient {
  background-size: 200% 200%;
  animation: gradientMove 2s ease-in-out infinite alternate;
}

@keyframes gradientMove {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}`],
})
export class PageAdminSettingsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( NgZone)  private zone: NgZone) { }

    public model: string = 'gpt-4o-mini';
    public originalSelectedModel: string = '';
    public newStopword: string = "";
    public stopwords = [];
    public menuFile = '';
    public faqs = [];
    public loaded = false;

    public modelOptions = [
        {
            name: 'GPT-4o mini',
            value: 'gpt-4o-mini',
            image: '/assets/images/gpt-4o-mini.png',
            description: '빠른 응답 속도와 안정적인 품질을 제공하는 범용 소형 모델'
        },
        {
            name: 'GPT-4.1 nano',
            value: 'gpt-4.1-nano',
            image: '/assets/images/gpt-4.1-nano.png',
            description: '짧은 대화와 단순 작업에 최적화된 초경량 모델'
        },
        {
            name: 'GPT-4.1 mini',
            value: 'gpt-4.1-mini',
            image: '/assets/images/gpt-4.1-mini.png',
            description: '높은 정확도와 자연스러운 대화를 제공하는 중간 규모 모델'
        }
    ];

    public newFaq = { question: '', answer: '' };
    public files = [];
    public fd = new FormData();
    public fds = new FormData();

    async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, '/login');
        await this.load();
    }

    public async load() {
        await this.service.loading.show();
        this.loaded = false;

        try {
            const { code, data } = await wiz.call("load");

            if (code !== 200) {
                return alert("ERROR: 오류 발생. 시스템 관리자에게 문의하세요.");
            }

            this.stopwords = data.stopwords;
            this.faqs = data.faq;
            this.menuFile = data.menu_file[0] || '';
            this.files = data.files;

            if (data.current_model) {
                let actualModel = data.current_model;

                if (typeof actualModel === 'string' && actualModel.startsWith('{')) {
                    try {
                        const parsedModel = JSON.parse(actualModel);

                        if (parsedModel.data && parsedModel.data.result) {
                            actualModel = parsedModel.data.result;
                        } else if (parsedModel.result) {
                            actualModel = parsedModel.result;
                        }
                    } catch (e) {
                    }
                }

                if (typeof actualModel === 'object') {
                    if (actualModel.data && actualModel.data.result) {
                        actualModel = actualModel.data.result;
                    } else if (actualModel.result) {
                        actualModel = actualModel.result;
                    } else {
                        actualModel = 'gpt-4o-mini';
                    }
                }

                this.zone.run(() => {
                    this.model = actualModel;
                });
            }

            this.loaded = true;
            await this.service.render();
        } catch (error) {
            alert("데이터 로드 중 오류가 발생했습니다.");
        } finally {
            await this.service.loading.hide();
        }
    }

    public async updateModel() {
        try {
            await this.service.loading.show();

            const { code, data } = await wiz.call("update_model", { model: this.model });

            if (code === 200) {
                const selectedModel = this.modelOptions.find(option => option.value === this.model);
                await this.alert(
                    "모델 변경 완료",
                    `모델이 '${selectedModel?.name || this.model}'로 변경되었습니다.`,
                    "success"
                );
            } else {
                await this.alert(
                    "모델 변경 실패",
                    data?.message || `모델 변경에 실패했습니다. (오류 코드: ${code})`,
                    "error"
                );
                await this.load();
            }
        } catch (error) {
            await this.alert(
                "모델 변경 실패",
                "모델 변경 중 오류가 발생했습니다. 다시 시도해주세요.",
                "error"
            );
            await this.load();
        } finally {
            await this.service.loading.hide();
        }
    }

    public async onModelSelect(selectedModel: string) {
        if (this.model !== selectedModel) {
            const selectedOption = this.modelOptions.find(option => option.value === selectedModel);
            const currentOption = this.modelOptions.find(option => option.value === this.model);

            const confirmed = await this.alert(
                "모델 변경 확인",
                `${selectedOption?.name || selectedModel}\n\n모델로 변경하시겠습니까?`,
                null,
                "변경",
                "취소"
            );

            if (confirmed) {
                this.originalSelectedModel = selectedModel;
                this.model = selectedModel;
                await this.updateModel();
            }
        }
    }

    public async addFaq() {
        if (!this.newFaq.question || !this.newFaq.answer) {
            return await this.alert("입력 오류", "질문과 답변을 입력해주세요.", "error");
        }

        if (this.faqs.some(f => f.question === this.newFaq.question)) {
            return await this.alert("중복 질문", "이미 존재하는 질문입니다.", "error");
        }

        const confirm = await this.alert(
            "FAQ 추가",
            "FAQ를 추가하시겠습니까?",
            null,
            "추가",
            "취소"
        );
        if (!confirm) return;

        const { code, data } = await wiz.call("add_faq", this.newFaq);

        if (code === 200 && data) {
            this.faqs = data;
            await this.alert("추가 완료", "FAQ가 성공적으로 추가되었습니다.", "success");
            this.zone.run(() => {
                this.newFaq = { question: '', answer: '' };
            });
        } else {
            await this.alert("추가 실패", "FAQ 추가 중 문제가 발생했습니다.", "error");
        }

        await this.service.render();
    }

    public async deleteFaq(faq: any) {
        const confirm = await this.alert(
            "FAQ 삭제",
            `"${faq.question}" 질문을 삭제하시겠습니까?`,
            "error",
            "삭제",
            "취소"
        );
        if (!confirm) return;

        if (faq.id) {
            const { code } = await wiz.call("delete_faq", faq);
            if (code === 200) {
                this.faqs = this.faqs.filter(f => f !== faq);
                await this.alert("삭제 완료", "FAQ가 성공적으로 삭제되었습니다.", "success");
            } else {
                await this.alert("삭제 실패", "FAQ 삭제 중 문제가 발생했습니다.", "error");
            }
        } else {
            await this.alert("삭제 불가", "저장되지 않은 FAQ입니다.", "error");
        }

        await this.service.render();
    }

    public async fileUpdate() {
        let url = wiz.url('update')

        const { code, data } = await this.service.file.upload(url, this.fd);
        if (code == 200) {
            await this.alert('저장되었습니다', '', 'success', '확인');
            this.fd = new FormData();  // 초기화 추가
        }

        await this.service.render();
    }

    public async filesUpdate() {
        let url = wiz.url('update_files')

        const { code, data } = await this.service.file.upload(url, this.fds);
        if (code == 200) {
            await this.alert('저장되었습니다', '', 'success', '확인');
            this.fds = new FormData();  // 초기화 추가
        }

        await this.service.render();
    }

    public async download() {
        let files = this.files;
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            let url = wiz.url('download?id=' + this.item.id + "&title=" + files)
            const link = document.createElement('a');
            link.href = url;
            link.download = file;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
        }
    }

    public async fileUpload(e) {
        let file = e.target.files[0];
        this.filename = file.name;
        this.menuFile = file.name;
        if (!file.filepath) file.filepath = file.name;
        this.fd.append('file[]', file);
        this.file = file.filepath;
        await this.service.render();
    }

    public async removeFile() {
        this.menuFile = '';
        this.fd = new FormData();
        await this.service.render();

        const { code } = await wiz.call("delete");
        if (code !== 200) {
            alert("파일 삭제 중 오류가 발생했습니다.");
        }
    }

    public async filesUpload(e) {
        for (let i = 0; i < e.target.files.length; i++) {
            let file = e.target.files[i];
            this.filename = file.name;

            if (!file.filepath) file.filepath = file.name;

            this.fds.append('file[]', file);
            this.files.push(file.filepath);
        }
        await this.service.render();
    }

    public async removeFiles(i) {
        let file = this.files[i]
        this.files.splice(i, 1);
        await this.service.render();
        const { code } = await wiz.call("delete_files", { file: file });
        if (code !== 200) {
            alert("파일 삭제 중 오류가 발생했습니다.");
        }
    }

    public async addStopword() {
        const word = this.newStopword.trim();
        if (!word) {
            return await this.alert("입력 오류", "금지어를 입력해주세요.", "error");
        }
        if (this.stopwords.includes(word)) {
            return await this.alert("중복 금지어", "이미 등록된 금지어입니다.", "error");
        }

        const res = await this.alert(
            "금지어 추가",
            `"${word}" 금지어를 추가하시겠습니까?`,
            null,
            "추가",
            "취소"
        );

        if (res) {
            const { code } = await wiz.call("add_stopword", { word });
            if (code === 200) {
                this.stopwords.push(word);
                await this.alert("추가 완료", "금지어가 성공적으로 추가되었습니다.", "success");
                this.newStopword = "";
            } else {
                await this.alert("추가 실패", "금지어 추가 중 문제가 발생했습니다.", "error");
            }
            await this.service.render();
        }
    }

    public vdbFiles: File[] = [];

    public async vdbFileSelect(e) {
        const input = e.target as HTMLInputElement;
        if (input.files?.length) {
            for (const file of Array.from(input.files)) {
                if (!this.vdbFiles.some(f => f.name === file.name)) {
                    this.vdbFiles.push(file);
                }
            }
            input.value = '';
        }
        await this.service.render();
    }

    public removeVdbFile(index: number) {
        this.vdbFiles.splice(index, 1);
        this.service.render();
    }

    public async uploadToVdb() {
        if (this.vdbFiles.length === 0) {
            return await this.alert("파일 선택", "업로드할 파일을 선택해주세요.", "error");
        }

        await this.service.loading.show();

        try {
            const formData = new FormData();
            for (const file of this.vdbFiles) {
                formData.append('files[]', file);
            }

            const url = wiz.url('set_file_to_vdb');
            const response = await fetch(url, {
                method: "POST",
                body: formData,
            });

            const result = await response.json();

            if (result.code === 200) {
                for (const file of this.vdbFiles) {
                    this.files.push(file.name);
                }
                await this.alert("저장 완료", "파일이 VDB에 성공적으로 저장되었습니다.", "success");
                this.vdbFiles = [];
            } else {
                await this.alert("업로드 실패", "파일 업로드에 실패했습니다.", "error");
            }

            await this.service.render();
        } catch (error) {
            console.error("Upload error:", error);
            await this.alert("오류 발생", "파일 업로드 중 오류가 발생했습니다.", "error");
        } finally {
            await this.service.loading.hide();
        }
    }

    public async deleteStopword(word: string) {
        const confirm = await this.alert(
            "금지어 삭제",
            `"${word}" 금지어를 삭제하시겠습니까?`,
            "error",
            "삭제",
            "취소"
        );

        if (!confirm) return;

        const { code } = await wiz.call("delete_stopword", { word });

        if (code === 200) {
            this.stopwords = this.stopwords.filter(w => w !== word);
            await this.alert("삭제 완료", "금지어가 성공적으로 삭제되었습니다.", "success");
        } else {
            await this.alert("삭제 실패", "금지어 삭제 중 문제가 발생했습니다.", "error");
        }

        await this.service.render();
    }

    public onUploadMultiple(event: Event, type: 'etc') {
        const input = event.target as HTMLInputElement;
        if (!input.files) return;

        if (type === 'etc') {
            this.etcFiles = Array.from(input.files);
        }
    }

    public removeEtcFile(file: File) {
        this.etcFiles = this.etcFiles.filter(f => f !== file);
    }

    public async alert(message: string, title: any = "", status: any = "error", action: string = '확인', cancel: any = false) {
        return await this.service.alert.show({
            title: title,
            message: message,
            action: action,
            actionBtn: status,
            cancel: cancel,
            status: status
        });
    }
}

export default PageAdminSettingsComponent;